import ExampleCodeBlock, {
  CodeParamType,
} from 'components/Docs/ExampleCodeBlock'

import { httpCodeExamples } from '../http-code-examples'

const js = `await integrationApp
  .integration('{INTEGRATION_KEY}')
  .getConnectorSpec()`

const rest = httpCodeExamples('/integrations/{INTEGRATION_KEY}/connector-spec')

export function GetConnectorSpecCodeExample() {
  return (
    <ExampleCodeBlock
      customCodes={{ js, ...rest }}
      parameters={{
        INTEGRATION_KEY: CodeParamType.IntegrationKey,
      }}
      run={async ({ integrationApp, parameters }) => {
        return await integrationApp
          .integration(parameters.INTEGRATION_KEY)
          .getConnectorSpec()
      }}
    />
  )
}
